import { render, staticRenderFns } from "./FacilityDetailModal.vue?vue&type=template&id=1588b274&scoped=true&lang=pug"
import script from "./FacilityDetailModal.vue?vue&type=script&lang=ts"
export * from "./FacilityDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./FacilityDetailModal.vue?vue&type=style&index=0&id=1588b274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1588b274",
  null
  
)

export default component.exports